<!--
  创建时间：2024/10/29 下午3:48
  创建人：toyeh
  文件描述：InfoPagination 类似信息管理页面的 分页器
-->

<template>
  <el-pagination
    class="table-pagination flex-center"
    background
    :hide-on-single-page="singlePageHide"
    :current-page="currentPage"
    :page-size="pageSize"
    :pager-count="5"
    prev-text="上一页"
    next-text="下一页"
    layout="total, prev, pager, next"
    :total="total"
    @current-change="handleCurrentChange"
  />
</template>

<script>
export default {
  name: "InfoPagination",
  components: {},
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    total: {
      type: Number,
      default: 0
    },
    singlePageHide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      curSdPage: 1
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.curSdPage = this.currentPage || 1
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    handleCurrentChange(val) {
      this.$emit("update:currentPage", Number(val))
      this.$emit("current-change", Number(val))
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        })
      })
    }
  }
};
</script>

<style scoped lang="scss">
.table-pagination{
	margin-top: 20px;
	margin-bottom: 50px;
	::v-deep {
		.el-pager li{
			width: 34px;
			height: 34px;
			line-height: 34px;
			background-color: #fff;
			color: #666;
			border: 1px solid #ddd;
		}
		.btn-prev,
		.btn-next {
			width: 70px;
			height: 34px;
			background-color: #fff;
			color: #666;
			border: 1px solid #ddd;
		}
		.btn-next {
			margin-right: 10px;
		}
	}
}
</style>
